module.exports = __webpack_public_path__ + "img/unchecked-favor_s.2e3a8daa.svg";